import Gooey, { Component, mount, VERSION } from '@srhazi/gooey';

const Greet: Component<{ name: string; dir?: string }> = ({
  name,
  dir = 'left',
}) => {
  return <marquee direction={dir}>Hello, {name}!</marquee>;
};

export const GreetExample = () => {
  return (
    <>
      <Greet name="world" />
      <Greet name={`Gooey ${VERSION}`} dir="right" />
    </>
  );
};
